module.exports = __webpack_public_path__ + "img/image1.2e46da12.jpg";